module.exports = __webpack_public_path__ + "media/Cogneetiv-Ping-NEW.1359c447.wav";